<template>
  <PageBranchList :branches="branches && branches.entities ? branches.entities : []"/>
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import PageBranchList from '@theme/components/content/PageBranchList'

const PAGE = {
  name: 'RouteBranchList',
  nuxtI18n: {
    paths: {
      cs: '/pobocky',
      de: '/niederlassungen',
      en: '/branches',
      sk: '/pobocky',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageBranchList,
  },
  mixins: [AppRouteMixin],
  async asyncData({ app, store, res }) {
    if (process.server) {
      res.set('X-Inspishop-Cache-Control', `public, max-age=${app.$env.STATELESS_TTL}`)
    }
    const data = {
      branches: store.dispatch('branch/LOAD_BRANCHES', { page: 0, perPage: 100 }),
    }
    const response = await Promise.allValues(data)
    store.commit('locale/SET_CANONICALS')
    return response
  },
}
export default PAGE
</script>
